import { api } from 'mixins/api';

export default {
  namespaced: true,
  state: {
    data: {},
    paymentsData: {}
  },
  mutations: {
    setUser(state, user) {
      state.data = Object.assign({}, state.data, user);
    },
    setPaymentsData(state, paymentsData) {
      state.paymentsData = Object.assign({}, state.paymentsData, paymentsData);
    },
  },
  actions: {
    async fetchPaymentsData({ commit }, userId) {
      try {
        const { data } = await api.get(`users/${ userId }/payments-data`)

        commit('setPaymentsData', data);
      } catch (e) {
        return Promise.reject(new Error('Не удалось загрузить реквизиты'));
      }
    },

    async fetchBalance({commit}, userId) {
      try {
        const {data} = await api.get(`/users/${userId}`)

        commit('setUser', data);
      } catch (e) {
        return Promise.reject(new Error('Не удалось загрузить баланс'));
      }
    }
  },
  getters: {
    data: state => {
      return state.data
    },
    balance: state => {
      return state.data.account_amount
    },
  },
}


// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/user.js